import { equals } from 'Data/aggregate.js'

export function getView(iconOnly, type, typeValue) {
  if (iconOnly) return false

  return equals(type, typeValue)
}
